<div class="airdrop-container" [ngClass]="httpService.theme">
    <cf-tabs [tabs]="tabs" [currentTab]="currentTab" (changed)="changeTab($event)"
        [theme]="httpService.theme"></cf-tabs>

    <div class="tabs">
        <app-airdrop *ngIf="currentTab === 'airdrop'"></app-airdrop>
        <app-airdrop-leaderboard *ngIf="currentTab === 'leaderboard'"></app-airdrop-leaderboard>
        <app-my-moon-history *ngIf="currentTab==='rewards'"></app-my-moon-history>
    </div>
</div>